import {handleDatePickerKeyDown} from "../../helpers/CalendarEventsRepeater";
import ru from "date-fns/locale/ru";
import DatePicker from "react-datepicker";
import React, {useEffect, useState} from "react";

interface Props {
    value?: Date;
    onChange?: (value?: Date) => void;
    readOnly?: boolean;
}

const AppDatePicker = (props: Props) => {
    return (

        <DatePicker
            readOnly={props.readOnly}
            selected={props.value}
            placeholderText={"Дата"}
            onChange={(value: Date) => {
                if (props.onChange)
                    props.onChange!(value);
            }}
            onKeyDown={handleDatePickerKeyDown}
            locale={ru}
            dateFormat="dd.MM.yyyy"

        />);
}

export default AppDatePicker;